export default "https://cdn-static-unstable.gokick.com/assets/6c6ec7987c723fb20ca76f9d1acc92ca38fc33c2/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";